









































import { Prop, Component, Vue } from "vue-property-decorator";
import { WeatherType } from "@/api/weather-api";

// 表示の仕方は変えたほうが良さそう
// - 細かい天気が表示できてよい
// - imgタグでなくてよさそう
// - 住所がない現場の天気を東京にする

const iconDict: { [weather: string]: string } = {
  // 取りうる値:
  // https://developer.apple.com/documentation/weatherkit/weathercondition?changes=__7_8
  Clear: "sun",
  MostlyClear: "sun",
  PartlyCloudy: "cloud-sun",
  Cloudy: "cloud",
  MostlyCloudy: "cloud",
  SunShowers: "umbrella", // 天気雨
  Drizzle: "umbrella", // 霧雨 小雨
  Rain: "umbrella",
  HeavyRain: "umbrella", // 大雨
  Thunderstorms: "umbrella", // 雷雨
  StrongStorms: "umbrella", // 激しい雷雨
  Flurries: "snowflake", //小雪
  Sleet: "snowflake", //みぞれ
  Snow: "snowflake",
  Fog: "smog",
  Wind: "wind"
};

@Component({})
export default class WeatherIcon extends Vue {
  @Prop({ required: true }) weather!: WeatherType;

  get type(): string {
    return iconDict[this.weather];
  }
}
